module.exports = __webpack_public_path__ + "img/weight4.83d7b6f7.svg";